import { useFormik } from 'formik';
import * as Yup from 'yup';
import _ from 'lodash';
import { regexCard, regexNumber, regexPhone } from '@helper_regex';
import { useDispatch, useSelector } from 'react-redux';
import {
    setCardData as setCardDataState,
    setCardErrors as setCardErrorsState,
    selectCheckoutState,
} from '@core_modules/checkout/redux/checkoutSlice';

const MidtransCore = (props) => {
    const {
        t,
        Content,
        installment_options = [],
        code,
    } = props;

    const dispatch = useDispatch();
    const checkout = useSelector(selectCheckoutState);
    const CARD_EXP_DEFAULT_VALUE = '-'; // as placeholder only
    const isCoreApiXendit = code?.match(/coreapixendit_/);

    let configValidation = {
        card_number: Yup.string().required(t('common:creditCard:validate:cardNumber:required'))
            .length(16, t('common:creditCard:validate:cardNumber:cardLength'))
            .matches(
                regexCard,
                t('common:creditCard:validate:cardNumber:wrong'),
            ),
        card_exp_month: Yup.string().required(t('common:creditCard:validate:month:required'))
            .notOneOf([CARD_EXP_DEFAULT_VALUE], t('common:creditCard:validate:month:required')),
        card_exp_year: Yup.string().required(t('common:creditCard:validate:year:required'))
            .notOneOf([CARD_EXP_DEFAULT_VALUE], t('common:creditCard:validate:year:required')),
        card_cvv: Yup.string().required(t('common:creditCard:validate:cvv:required'))
            .length(3, t('common:creditCard:validate:cvv:cardLength'))
            .matches(regexNumber, t('common:creditCard:validate:cvv:wrong')),
        ...isCoreApiXendit && {
            card_holder_firstname: Yup.string().required(t('common:creditCard:validate:card_holder_firstname:required')),
            card_holder_lastname: Yup.string().required(t('common:creditCard:validate:card_holder_lastname:required')),
            card_holder_email: Yup.string().email(t('common:creditCard:validate:card_holder_email:wrong'))
                .required(t('common:creditCard:validate:card_holder_email:required')),
            card_holder_phone_number: Yup.string().required(t('common:creditCard:validate:card_holder_phone_number:required'))
                .matches(regexPhone, t('validate:phoneNumber:wrong')).max(13, t('validate:phoneNumber:wrong')),
        },
    };

    if (!_.isEmpty(installment_options)) {
        configValidation = {
            ...configValidation,
            tenor: Yup.number().required(t('common:creditCard:validate:selectInstallmentSchema:required')),
        };
    }

    const cardValidation = Yup.object().shape(configValidation);

    const formik = useFormik({
        initialValues: {
            card_number: checkout.cardData.card_number || '',
            card_exp_month: checkout.cardData.card_exp_month || CARD_EXP_DEFAULT_VALUE,
            card_exp_year: checkout.cardData.card_exp_year || CARD_EXP_DEFAULT_VALUE,
            card_cvv: checkout.cardData.card_cvv || '',
            tenor: checkout.cardData.tenor || '',
            card_holder_firstname: checkout.cardData.card_holder_firstname || '',
            card_holder_lastname: checkout.cardData.card_holder_lastname || '',
            card_holder_email: checkout.cardData.card_holder_email || '',
            card_holder_phone_number: checkout.cardData.card_holder_phone_number || '',
        },
        validateOnMount: true,
        validateOnBlur: true,
        validateOnChange: true,
        validationSchema: cardValidation,
        onSubmit: () => {},
    });

    const yearList = () => {
        const currentYear = new Date().getFullYear();
        const placeholderValue = { label: 'Tahun', value: CARD_EXP_DEFAULT_VALUE };
        const years = [];

        years.push(placeholderValue);
        for (let i = currentYear; i <= currentYear + 7; i += 1) {
            const year = { label: i, value: i };
            years.push(year);
        }
        return years;
    };

    const months = [
        { label: 'Bulan', value: CARD_EXP_DEFAULT_VALUE }, // as placeholder only
        { label: '01 - Januari', value: 1 },
        { label: '02 - Februari', value: 2 },
        { label: '03 - Maret', value: 3 },
        { label: '04 - April', value: 4 },
        { label: '05 - Mei', value: 5 },
        { label: '06 - Juni', value: 6 },
        { label: '07 - July', value: 7 },
        { label: '08 - Agustus', value: 8 },
        { label: '09 - September', value: 9 },
        { label: '10 - Oktober', value: 10 },
        { label: '11 - November', value: 11 },
        { label: '12 - Desember', value: 12 },
    ];

    React.useEffect(() => {
        dispatch(setCardDataState({ ...formik.values }));
    }, [formik.values]);

    React.useEffect(() => {
        dispatch(setCardErrorsState({ ...formik.errors }));
    }, [formik.errors]);

    const contentProps = {
        ...props,
        formik,
        yearList,
        months,
        checkout,
        isCoreApiXendit,
    };

    return (
        <Content {...contentProps} />
    );
};

export default MidtransCore;
